<template lang="pug">
  .pdp-swatch-selector-grid(v-if="showSwatchSelector")
    .swatches-wrap
      PdpSwatchButton.swatch-wrap(
        v-for="prod in productsSortedByLevel"
        :key='prod.code'
        :url="`/product/${prod.url_key}`"
        :selected="prod.code == product.code"
        :label="prod.shortName || prod.name"
        :hide-label="true"
        :img-url="swatchImage(prod).url"
        :img-alt-text="''"
        tabindex="0"
        :class="{'has-dot': recommendedSwatch(prod)}"
      )

</template>

<script>
  import { mapState } from 'vuex';
  import PdpSwatchButton from "../PdpSwatchButton/PdpSwatchButton";
  import bestMatchMixin from '@mixins/bestMatchMixin';

  export default {
    name: "PdpSwatchSelectorGrid",

    components: {
      PdpSwatchButton
    },

    mixins: [bestMatchMixin],
    inject: ['getObjProperty', 'getObjPropertyCatchUndefined'],

    computed: {
      ...mapState('pdp', ['product', 'productsForProductType']),
      ...mapState('xsell', ['xsellForActiveColorKitSubs']),
      ...mapState('colorAdvisor', ['rootPerfectionRecommendation']),

      productsSortedByLevel() {
        let sortedProducts = [...this.productsForProductType];

        return sortedProducts.sort((a, b) => {
          if (a.shadeLevel == b.shadeLevel) {
            return 0;
          } else if (a.shadeLevel < b.shadeLevel) {
            return -1;
          } else {
            return 1;
          }
        });
      },

      showSwatchSelector() {
        return !!this.product.groupByProductType;
      },
    },

    methods: {
      swatchImage(prod) {
        if (this.getObjProperty(prod, 'imagery.pdpSelector.url')) {
          return prod.imagery.pdpSelector;
        } else if (this.getObjPropertyCatchUndefined(prod, 'imagery.standard.url')) {
          return prod.imagery.standard;
        }

        return {};
      },

      recommendedSwatch(prod) {
        if (prod.product_type == "root_reboot") {
          let match = this.mix_bestMatchObj(prod.product_type);
          return (match && match.code == prod.code);
        }

        if (prod.product_type === "root_perfection") {
          return this.rootPerfectionRecommendation && this.rootPerfectionRecommendation.code === prod.code;
        }

        if (!this.xsellForActiveColorKitSubs || !this.xsellForActiveColorKitSubs.length) {
          return false;
        }

        return this.xsellForActiveColorKitSubs.some(subXsell => {
          if (!subXsell.xsell || !subXsell.xsell) {
            return false;
          }
          return subXsell.xsell.some(product => product.code == prod.code);
        });
      },
    },
  };
</script>

<style scoped lang="stylus">
  .pdp-swatch-selector-grid
    position relative
    width 100%
    overflow hidden
    padding 1em 0

    .swatch-wrap
      position relative
      display inline-block
      vertical-align top
      width 5.25em
      text-align center
      white-space normal

      &.has-dot
        &:after
          content ''
          display block
          position absolute
          top 0.5em
          right 0.5em
          width 0.85em
          height 0.85em
          border 2px solid color-white
          border-radius 50%
          background-color brand-color-2

      .swatch
        display inline-block
        width 5em
        height 5em
        border-radius 50%
        padding 4px
        border 4px solid color-white

        .swatch-inner
          position relative
          width 100%
          height 100%
          border-radius 50%
          overflow hidden

      &.selected
        .swatch
          border-color brand-color-2

      .swatch-text
        display inline-block
        margin-top 0.25em

</style>
